import React from 'react';

function LineSvg() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='79'
			height='6'
			viewBox='0 0 79 6'
		>
			<path fill='#22294d' d='M0 0H79V6H0z' data-name='Rectangle 11264'></path>
		</svg>
	);
}

export default LineSvg;
